import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { User } from 'src/app/shared/models/security/user';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BeneficiaireModalAjoutFormComponent } from '../modal/beneficiaire-modal-ajout-form/beneficiaire-modal-ajout-form.component';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Observable, Subject, Subscriber, debounceTime, delay, mergeMap, of, take } from 'rxjs';
import { LogService } from 'src/app/core/services/log/log.service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { RegionApiResponse, RegionCodeApiResponse } from 'src/app/shared/models/api-response/regionapi-response';
import { Region } from 'src/app/shared/models/region';
import { Departement } from 'src/app/shared/models/departement';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-beneficiaire',
	templateUrl: './list-beneficiaire.component.html',
	styleUrls: ['./list-beneficiaire.component.scss']
})
export class ListBeneficiaireComponent implements OnInit {
	beneficiaires: Beneficiaire[];
	currentPage = 1;
	totalItems;
	totalPages;

	beneficiaireCsvFile: File = null;
	sortType = 'lastName';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	handicaps: Record<string, string>;

	listExpertise: TypeHandicap[];
	listSelectedExpertise: TypeHandicap[] = [];
	listRegion: Region[];
	listDepartement: Departement[];

	searchedInput = '';

	// nombre de page totale pour la pagination
	itemsPerPage = 10;

	user: User = null;
	isPlanif = false;
	labelBeneficiaireCapitalized: string;
	labelBeneficiairePluralized: string;

	isIntervenant: boolean;
	isAdmin: boolean;

	ajoutBeneficiaireModalref: BsModalRef;

	isAddable = false;
	isImportable = true;
	isExportable = true;

	isMobile = false;
	screenWidth: number;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive: boolean;

	searchResults: RegionCodeApiResponse[];

	isListingLoading: boolean = true;

	private searchSubject = new Subject<string>();

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {
		// ajout de délai à la saisie de recherche pour ne pas bombarder le back de requête
		this.searchSubject
			.pipe(
				debounceTime(300) // Délai en millisecondes
			)
			.subscribe(() => {
				this.searchByInput();
			});
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.labelBeneficiaireCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelBeneficiairePluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_BENEFICIAIRE
			);

		this.user = this.facade.dataStorageService.getUser();
		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();

		this.isIntervenant = this.facade.dataStorageService.isIntervenant();
		this.isAdmin = this.facade.dataStorageService.isAdmin();

		if(this.facade.dataStorageService.getService() != null){
			this.isAddable = true;
		}

		this.facade.regionService.getAllRegion().subscribe({
			next: (val) => {
				this.listRegion = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		this.facade.departementService.getAllDepartement().subscribe({
			next: (val) => {
				this.listDepartement = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		this.getBeneficiairesMinimal();
	}

	getBeneficiairesMinimal(): void {
		this.isListingLoading = true;
		if(this.isIntervenant){
			this.facade.beneficiaireService
				.getByIntervenant(this.facade.dataStorageService.getUser()?.id)
				.subscribe({
					next: (beneficiaires: Beneficiaire[]) => {
						this.beneficiaires = beneficiaires;
						this.isListingLoading = false;
					},
					error: (err: ErrorResponse) => {
						this.logger.error(err + '');
					},
					complete: () => {
						this.isListingLoading = false;
					}
				});
		// }else if(this.isAdmin){
		// 	this.facade.beneficiaireService
		// 		.getAllBeneficiaires()
		// 		.subscribe({
		// 			next: (beneficiaires: Beneficiaire[]) => {
		// 				this.beneficiaires = beneficiaires;
		// 				this.currentPage = 1;
		// 				this.isListingLoading = false;
		// 				var codePostal;
		// 				var pattern = new RegExp(/\b\d{5}\b/g);
		// 				let beneficiaireWithoutRegion : Beneficiaire[] = [];

		// 				for(let i = 0; i < this.beneficiaires.length; i++){
		// 					if(this.beneficiaires[i].address != null && this.beneficiaires[i].departement == null){
		// 						codePostal = this.beneficiaires[i].address.label.match(pattern);
		// 						console.log(this.beneficiaires[i].firstName + this.beneficiaires[i].lastName);
		// 						if(codePostal != null){
		// 							beneficiaireWithoutRegion.push(this.beneficiaires[i]);
		// 						}
		// 					}
		// 				}

		// 				for(let i = 0; i < beneficiaireWithoutRegion.length; i++){
		// 					console.log(i);
		// 					let codePostalNew = beneficiaireWithoutRegion[i].address.label.match(pattern);
		// 					this.getDepartementFromAddress(codePostalNew[0].substring(0, 2), beneficiaireWithoutRegion[i]);
		// 				}
		// 			},
		// 			error: (err: ErrorResponse) => {
		// 				this.logger.error(err + '');
		// 			},
		// 			complete: () => {
		// 				this.isListingLoading = false;
		// 			}
		// 		});
		}else{
				this.facade.beneficiaireService.getByServiceAndRegionPagination(this.facade.dataStorageService.getService()?.id,
				this.facade.dataStorageService.getRegion()?.id, this.currentPage - 1, this.itemsPerPage, this.searchedInput).subscribe({
					next: (res) => {
						console.log(res);
						this.beneficiaires = res.content;
						this.totalItems = res.totalElements;
						this.totalPages = res.totalPages;
						this.currentPage = res.number + 1;
						this.isListingLoading = false;
					},
					error: (err: ErrorResponse) => {
						this.logger.error(err + '');
						this.isListingLoading = false;
					}
				});
		}
	}

	getDepartementFromAddress(codePostal: string, beneficiaire: Beneficiaire) {
		console.log(codePostal);
		this.listDepartement.forEach(dep => {
					if(dep.code == codePostal){
						beneficiaire.departement = dep;
						this.facade.beneficiaireService.updateBeneficiaire(beneficiaire).subscribe({
							error: (err) => {
								this.logger.error(err);
							}
						})
					}
				})
			
	}

	getRegionFromAddress(codePostal: string, beneficiaire: Beneficiaire) {
		console.log(codePostal);
		this.facade.nominatimService.regionCodeLookup(codePostal).subscribe({
			next: (result: any) => {
				this.searchResults = result.map(
					(result) =>
						new RegionCodeApiResponse(
							result.nom,
							result.code,
							result.codeDepartement,
							result.siren,
							result.codeEpci,
							result.codeRegion,
							result.codesPostaux,
							result.population
						)
				);
				console.log(this.searchResults);
				this.listRegion.forEach(reg => {
					if(reg.departements.find(dep => dep.code == this.searchResults[0].codeDepartement)){
						console.log(reg);
						beneficiaire.region = reg;
						this.facade.beneficiaireService.updateBeneficiaire(beneficiaire).subscribe({
							error: (err) => {
								this.logger.error(err);
							}
						})
					}
				})
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
	}

	/*getBeneficiairesExpertises(beneficiaires: Beneficiaire[]): TypeHandicap[] {
		return beneficiaires
			.flatMap((beneficiaire) => beneficiaire.typeHandicaps)
			.filter((v, i, a) => a.findIndex((t) => t?.id === v?.id) === i)
			.sort((a, b) => a.name.localeCompare(b.name));
	}*/

	selectBeneficiaire(beneficiaire: Beneficiaire): void {
		const link = ['/gestion/beneficiaires', beneficiaire.id];
		this.router.navigate(link);
	}

	importBeneficiaires(event: any): void {
		this.isImportable = false;
		this.beneficiaireCsvFile = event.target.files[0];
		this.facade.beneficiaireService
			.importBeneficiaires(this.beneficiaireCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.facade.toastService.createSuccessToast('Import effectué');
					this.getBeneficiairesMinimal();
					this.isImportable = true;
				},
				error: (err: ErrorResponse) => {
					this.isImportable = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	exportBeneficiaires(): void {
		this.facade.exportService
			.exportBeneficiaires()
			.subscribe((blob) => saveAs(blob, 'beneficiaire.csv'));
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	onKeyUp() {
		this.searchSubject.next(this.searchedInput);
	}


	searchByInput() {
		this.currentPage = 1;
		this.getBeneficiairesMinimal();
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		// const initialState = {
		// 	serviceCenter: this.user.employee.serviceCenter
		// };
		// if (this.user === null || this.user.employee.serviceCenter === null) {
		// 	this.facade.toastService.createErrorToast(
		// 		"Vous n'êtes pas rattaché à un centre."
		// 	);
		// } else {
			this.ajoutBeneficiaireModalref = this.modalService.show(
				BeneficiaireModalAjoutFormComponent,
				{
					class: 'modal-lg',
					//initialState,
					backdrop: 'static'
				}
			);
			this.ajoutBeneficiaireModalref.content.updateListing
				.pipe(take(1))
				.subscribe((addedBeneficiaire: Beneficiaire) => {
					this.beneficiaires.push(addedBeneficiaire);
				});
		//}
	}

	onItemsPerPageChange(): void {
		this.currentPage = 1;
		this.getBeneficiairesMinimal();
	  }
	  

	onPageChange(pageNumber: any): void {
		this.currentPage = pageNumber;
		this.getBeneficiairesMinimal();
	}

	onInputChange() {
		this.getBeneficiairesMinimal();
	}

	updateSelectedExpertise(e: any, spe: TypeHandicap) {
		if (e.target.checked) {
			if (!this.listSelectedExpertise.some((e) => e.id === spe.id)) {
				this.listSelectedExpertise = [...this.listSelectedExpertise];
				this.listSelectedExpertise.push(spe);
			}
		} else {
			if (this.listSelectedExpertise.some((e) => e.id === spe.id)) {
				this.listSelectedExpertise = this.listSelectedExpertise.filter(
					(e) => e.id !== spe.id
				);
			}
		}
	}
}
